import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from './cn';

/**
 * Flat, hairline-bordered card (DESIGN §5). Hover (interactive only): border→Accent Blue,
 * translateY(-2px), 220ms ease-out-quart. No shadow change. Never nest cards.
 */
export function Card({
  interactive,
  className,
  children,
  ...rest
}: HTMLAttributes<HTMLDivElement> & { interactive?: boolean }) {
  return (
    <div
      className={cn(
        'rounded-md border-[0.5px] border-hairline bg-canvas-paper p-lg text-ink-graphite',
        interactive &&
          'cursor-pointer transition-transform duration-almanac ease-almanac hover:-translate-y-[2px] hover:border-accent-blue focus-visible:shadow-focus',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}

export function CardHeader({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn('mb-md flex items-start justify-between gap-md', className)}>{children}</div>;
}
